import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import ProductSaleCreateForm from './product-sales/ProductSaleCreateForm';
import MaterialSaleCreateForm from './material-sales/MaterialSaleCreateForm';
import SparepartSaleCreateForm from './sparepart-sales/SparepartSaleCreateForm';

const SaleCreateForm = ({ show, handleClose }) => {
    const [selectedType, setSelectedType] = useState('product');

    const handleTypeSelect = (type) => {
        setSelectedType(type);
    };

    if (!show) return null;

    return (
        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {selectedType === 'product' ? 'Yangi mahsulot sotuvi' : 
                     selectedType === 'material' ? 'Yangi material sotuvi' : 'Yangi ehtiyot qism sotuvi'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4 d-flex justify-content-center">
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="productSale"
                        label="Mahsulot sotuvi"
                        checked={selectedType === 'product'}
                        onChange={() => handleTypeSelect('product')}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="materialSale"
                        label="Material sotuvi"
                        checked={selectedType === 'material'}
                        onChange={() => handleTypeSelect('material')}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="sparepartSale"
                        label="Ehtiyot qism sotuvi"
                        checked={selectedType === 'sparepart'}
                        onChange={() => handleTypeSelect('sparepart')}
                    />
                </div>
                {selectedType === 'product' ? (
                    <ProductSaleCreateForm onClose={handleClose} />
                ) : selectedType === 'material' ? (
                    <MaterialSaleCreateForm onClose={handleClose} />
                ) : (
                    <SparepartSaleCreateForm onClose={handleClose} />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SaleCreateForm;
